import {parseQueryString} from './query.utils';

const _q = parseQueryString();


function isMobile() {
  return 'im' in _q || window.matchMedia('only screen and (max-width: 480px)').matches;
}

function isTablet() {
  return 'it' in _q || window.matchMedia('only screen and (max-width: 768px)').matches;
}

const IS_MOBILE = isMobile();
const IS_TABLET = isTablet();

export {
  IS_MOBILE,
  IS_TABLET,
};



// WEBPACK FOOTER //
// ./src/app/common/device-info.utils.js